import { ListaPreciosVentaGeneral } from './ListaPreciosVentaGeneral';
import { ListaPreciosVentaDetalle } from './ListaPreciosVentaDetalle';

export class ListaPrecios{

	public idCompania: string;
	public realizoAlta: string;
	public realizoCambio: string;
	public listaPreciosGeneral: ListaPreciosVentaGeneral;
	public listaPreciosDetalles: ListaPreciosVentaDetalle[];
	public ventaCompra;

	constructor(){
		this.idCompania = null;
		this.realizoAlta = null;
		this.realizoCambio = null;
		this.listaPreciosGeneral = new ListaPreciosVentaGeneral();
		this.listaPreciosDetalles = [];
	}

}


// WEBPACK FOOTER //
// ./src/app/models/ListaPrecios.ts